import { CancelButton, SaveButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { useApiUtils } from '@core/util/apiUtils';
import { ContaReceberContext } from 'app/main/contareceber/contaReceberContext';
import { ContaReceberRecorrenciaContext } from 'app/main/contareceber/contaReceberRecorrenciaContext';
import { excluirAlert } from 'app/services/alerts';
import contaReceberApi from 'app/services/api/contaReceberApi';
import contaReceberRecorrenciaApi from 'app/services/api/contaReceberRecorrenciaApi';
import * as Actions from 'app/store/actions';
import { eventReactGA } from 'app/utils/analyticsUtil';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ContaReceberRecorrenciaTable from '../ContaReceberRecorrenciaTable';
import { contaReceberModais } from './contaReceberModais';

const ContasReceberRecorrenciaModal = ({ fetchContasReceber, showSuccess }) => {
  const [selecao] = useContext(ContaReceberRecorrenciaContext).selecao;
  const [tipoSelecao] = useContext(ContaReceberRecorrenciaContext).tipoSelecao;
  const [modal, setModal] = useContext(ContaReceberContext).modal;

  const [dataVencimentoInicio, setDataVencimentoInicio] = useContext(
    ContaReceberRecorrenciaContext
  ).dataVencimentoInicio;
  const [dataVencimentoFim, setDataVencimentoFim] = useContext(ContaReceberRecorrenciaContext).dataVencimentoFim;

  const [, setLoading] = useContext(ContaReceberRecorrenciaContext).loading;
  const [, setTotalElements] = useContext(ContaReceberRecorrenciaContext).totalElements;
  const [, setRecorrencias] = useContext(ContaReceberRecorrenciaContext).recorrencias;
  const [page] = useContext(ContaReceberRecorrenciaContext).page;
  const [size] = useContext(ContaReceberRecorrenciaContext).size;
  const [sort] = useContext(ContaReceberRecorrenciaContext).sort;

  const [contaReceberPage] = useContext(ContaReceberContext).page;
  const [contaReceberSize] = useContext(ContaReceberContext).size;
  const [contaReceberSort] = useContext(ContaReceberContext).sort;
  const [contaReceberSearch] = useContext(ContaReceberContext).search;
  const [filtroAvancado] = useContext(ContaReceberContext).filtroAvancado;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useEffect(() => {
    const dataInicio = moment().startOf('month');
    const dataFim = moment().endOf('month');

    setDataVencimentoInicio(dataInicio);
    setDataVencimentoFim(dataFim);

    fetchRecorrencias({
      ...initialPage,
      dataVencimentoInicio: dataInicio.format('YYYY-MM-DD'),
      dataVencimentoFim: dataFim.format('YYYY-MM-DD'),
    });
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancelar = () => {
    setModal('');
    const dataInicio = moment().startOf('month');
    const dataFim = moment().endOf('month');

    setDataVencimentoInicio(dataInicio);
    setDataVencimentoFim(dataFim);
  };

  const handleDeleteRecorrencia = async (recorrencia) => {
    excluirAlert({
      confirmar: async () => {
        try {
          setLoading(true);
          await contaReceberApi.excluir({ ids: [recorrencia.id], apenasRegulares: true });
          showSuccess('Receita regular excluída com sucesso.');

          fetchRecorrencias({
            page,
            size,
            sort,
            dataVencimentoInicio: dataVencimentoInicio.format('YYYY-MM-DD'),
            dataVencimentoFim: dataVencimentoFim.format('YYYY-MM-DD'),
          });
        } catch (err) {
          apiUtils.handleApiError(err);
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleResgatar = async () => {
    if ((selecao && selecao.length > 0) || tipoSelecao === 'TODOS_FILTRO') {
      setLoading(true);

      try {
        eventReactGA('Conta a receber', 'Resgatar contas a receber agendadas');
        await contaReceberRecorrenciaApi.resgatar({
          tipoSelecao,
          ids: selecao?.map((item) => item?.id),
          dataVencimentoInicio,
          dataVencimentoFim,
        });

        fetchContasReceber({
          page: contaReceberPage,
          size: contaReceberSize,
          sort: contaReceberSort,
          q: contaReceberSearch,
          filtroAvancado,
        });

        setModal('');

        fetchRecorrencias({
          page,
          size,
          sort,
          dataVencimentoInicio: dataVencimentoInicio.format('YYYY-MM-DD'),
          dataVencimentoFim: dataVencimentoFim.format('YYYY-MM-DD'),
        });
      } catch (err) {
        apiUtils.handleApiError(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const initialPage = {
    page: 0,
    size: 15,
    sort: 'dataVencimento,DESC',
  };

  const fetchRecorrencias = async (search = initialPage) => {
    setLoading(true);

    try {
      const response = await contaReceberRecorrenciaApi.buscar(search);

      setTotalElements(response.data.totalElements);

      setRecorrencias(response.data.content);
    } catch (err) {
      apiUtils.handleApiError(err);
    }
    setLoading(false);
  };

  return (
    <SimpleDialog open={modal === contaReceberModais.resgatarContaReceber} onClose={handleCancelar}>
      <SimpleDialogContent
        header={{
          title: 'Receitas regulares',

          toolbar: (
            <>
              <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                Cancelar
              </CancelButton>
              <SaveButton color="buttonSave" type="button" onClick={handleResgatar}>
                Resgatar
              </SaveButton>
            </>
          ),
        }}
        content={
          <ContaReceberRecorrenciaTable
            fetchRecorrencias={fetchRecorrencias}
            handleDeleteRecorrencia={handleDeleteRecorrencia}
          />
        }
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
};

export default ContasReceberRecorrenciaModal;
